__turbopack_context__.v({
  "container": "TabNavigation-module__ZDd06W__container",
  "content": "TabNavigation-module__ZDd06W__content",
  "contentText": "TabNavigation-module__ZDd06W__contentText",
  "hint": "TabNavigation-module__ZDd06W__hint",
  "tab": "TabNavigation-module__ZDd06W__tab",
  "tabActive": "TabNavigation-module__ZDd06W__tabActive",
  "tabs": "TabNavigation-module__ZDd06W__tabs",
});
